module.exports = __webpack_public_path__ + "img/symbol2.0a32da42.svg";